module.exports = __webpack_public_path__ + "static/media/card-logo-unknown.ca0bf97e.svg";